var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadCover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 1H2.5C1.94772 1 1.5 1.44772 1.5 2V10.2998L3.84286 7.9988C4.42638 7.4257 5.36146 7.4257 5.94498 7.9988L7.54306 9.56834C7.73156 9.75348 8.03159 9.76 8.22795 9.58321L11.9211 6.25827C12.5102 5.72791 13.4103 5.74745 13.9758 6.30288L15.5 7.79986V2C15.5 1.44772 15.0523 1 14.5 1ZM1.5 14V11.5361L4.54357 8.71225C4.73807 8.52122 5.04977 8.52122 5.24427 8.71225L6.84235 10.2818C7.40788 10.8372 8.30794 10.8568 8.89704 10.3264L12.5902 7.00146C12.7866 6.82467 13.0866 6.83118 13.2751 7.01632L15.5 9.19787V14C15.5 14.5523 15.0523 15 14.5 15H2.5C1.94772 15 1.5 14.5523 1.5 14ZM2.5 0C1.39543 0 0.5 0.895431 0.5 2V14C0.5 15.1046 1.39543 16 2.5 16H14.5C15.6046 16 16.5 15.1046 16.5 14V2C16.5 0.895431 15.6046 0 14.5 0H2.5ZM8.5 5C8.5 5.55228 8.05228 6 7.5 6C6.94772 6 6.5 5.55228 6.5 5C6.5 4.44772 6.94772 4 7.5 4C8.05228 4 8.5 4.44772 8.5 5ZM9.5 5C9.5 6.10457 8.60457 7 7.5 7C6.39543 7 5.5 6.10457 5.5 5C5.5 3.89543 6.39543 3 7.5 3C8.60457 3 9.5 3.89543 9.5 5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCover);
export default __webpack_public_path__ + "static/media/upload-cover.0bf00ad68f8502ed2c58ada77d4cf7a1.svg";
export { ForwardRef as ReactComponent };